import type { CourseTargetObjetive } from "../entities/courses"

export const target: Record<CourseTargetObjetive, { value: string; description: string }> = {
  approve: {
    value: "Aprobar",
    description: "Aprobar",
  },
  outstanding: {
    value: "Destacar",
    description: "Destacar",
  },
  excel: {
    value: "Sobresalir",
    description: "Sobresalir",
  },
}
